<script>
import { mapState, mapGetters } from 'vuex'
import dayjs from 'dayjs'

const defaultReservationDuration = 15
export default {
  name: 'EventDataMixin',

  data () {
    return {
      now: new Date(),
      reservationDuration: defaultReservationDuration
    }
  },

  computed: {
    ...mapState(['resourceEvents', 'resourceCalendars', 'currentResourceId']),
    ...mapGetters(['currentEvents']),
    roomCurrentStatus () {
      return this.$googleCalendarService.getRoomState(this.currentEvents, this.now)
    },
    leftDurationMinutes () {
      return dayjs(this.roomCurrentStatus.leftDuration).minute() + dayjs(this.roomCurrentStatus.leftDuration).hour() * 60
    }
  },

  created () {
    setInterval(() => {
      this.now = new Date()
      this.newEventFromTime = dayjs().format('YYYY-MM-DDTHH:mm')
      this.newEventToTime = dayjs().add(this.reservationDuration, 'minute').format('YYYY-MM-DDTHH:mm')
    }, 1000)
  }
}
</script>
